<template>
  <v-dialog :model-value="true" max-width="560" @update:model-value="onClose">
    <v-card>
      <v-card-title class="text-h6">{{ $t('live_demo.dialog_title') }}</v-card-title>
      <v-card-text>
        <p class="mb-3">{{ $t('live_demo.dialog_hint') }}</p>
        <v-text-field
          :model-value="fullUrl"
          readonly
          hide-details
          density="comfortable"
          variant="outlined"
          data-testid="live-demo-url"
          :input-props="{ 'data-testid': 'live-demo-url-input' }"
        >
          <template #append-inner>
            <v-btn icon size="small" variant="text" :title="$t('live_demo.copy')" @click="copyUrl">
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="onClose">{{ $t('live_demo.close') }}</v-btn>
        <v-btn color="primary" :href="path" target="_blank" rel="noopener">
          {{ $t('live_demo.open') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'LiveDemoUrlDialog',
  props: {
    path: { type: String, required: true },
  },
  computed: {
    fullUrl() {
      if (!this.path) {
        return '';
      }
      if (this.path.startsWith('http')) {
        return this.path;
      }
      return `${window.location.origin}${this.path}`;
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.fullUrl);
        await this.$store.dispatch('snackbars/add_success_snack', this.$t('live_demo.copied'));
      } catch {
        await this.$store.dispatch('snackbars/add_failed_snack', this.$t('live_demo.copy_failed'));
      }
    },
  },
};
</script>
